const axios = require('axios');


export function getCategories() {
  return axios.get(process.env.API_URL+'/categories')
  .then(function(response) {
    return response['data']['item'];
  });
}


// WEBPACK FOOTER //
// ./src/api/categories.js